module.exports = __webpack_public_path__ + "public/img/tulier.0f1f355c.png";